import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";

const AttorneyMenu = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    //dispatch(litigantMenuActions.getLitigantMenuOptions());
  }, [dispatch]);

  return (
    <Row>
      <Col style={{ marginTop: "25px" }} xs={12}>
        <h4>ATTORNEY RESOURCES</h4>
      </Col>
      <Col style={{ marginTop: "5px" }} xs={12}>
        <Row>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Personal Info</h5>
            <Link to="/attorney/updatePersonalInfo" className="sideBarMenuItem">
              <span>Update personal info</span>
            </Link>
            <br />
            <Link to="/attorney/updatePassword" className="sideBarMenuItem">
              <span>Update password</span>
            </Link>
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Appointments</h5>
            <Link
              to="/attorney/upcomingAppointments"
              className="sideBarMenuItem"
            >
              <span>Upcoming appointments</span>
            </Link>
            <br />
            <Link
              to="/attorney/availableAppointments"
              className="sideBarMenuItem"
            >
              <span>Available appointments</span>
            </Link>
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Sign Out</h5>
            <Link to="/" className="sideBarMenuItem">
              <span>Sign out</span>
            </Link>
            <br />
          </Col>
          <Col xs={12} className="psInfo"></Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AttorneyMenu;
